import { MaintenanceTypeAttributes } from '@/types'
import { UpdateMaintenanceTypeMutation } from './__generated__/update_mutation'
import { Mutation as UpdateMutation } from './update_mutation'
import { useForm } from '@/helpers/useForm'
import { EditMaintenanceTypesQuery } from './__generated__/edit_query'
import { Query as EditQuery } from './edit_query'
import { Inline as Loading } from '@/components/loading'
import { Inline as Error } from '@/components/error'
import { useEffect, useState } from 'react'
import { DeleteDialog } from '../delete_dialog'
import { Mutation as DeleteMutation } from './delete_mutation'
import { Query as TableQuery } from './table_query'
import { Button } from '../base/button'

type MaintenanceTypes = EditMaintenanceTypesQuery['maintenanceTypes']['nodes'][0]

interface Props {
  id: string
  onSuccess: () => void
}

export const Form = ({ id, onSuccess }: Props) => {
  const {
    save,
    saveSuccess,
    formBuilder,
    queryError,
    queryLoading,
    mutationLoading,
  } = useForm<
    UpdateMaintenanceTypeMutation,
    MaintenanceTypeAttributes,
    EditMaintenanceTypesQuery,
    MaintenanceTypes
  >({
    id,
    initializer: mt => ({
      name: mt.name || '',
      color: mt.color || ''
    }),
    query: EditQuery,
    queryKey: 'maintenanceTypes',
    mutation: UpdateMutation,
    resultKey: 'updateMaintenanceType'
  })
  const [showDelete, setShowDelete] = useState(false)

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  const onDelete = () => {
    setShowDelete(false)
    onSuccess()
  }

  if (queryLoading) return <Loading />

  return (
    <>
      { queryError && <Error message={queryError} /> }
      <div className="flex flex-col gap-6">
        { formBuilder.buildQueryError() }
        { formBuilder.buildField({ name: 'Name', field: 'name', type: 'text' }) }
        { formBuilder.buildField({ name: 'Color', field: 'color', type: 'color' }) }
        <div className="flex flex-row justify-between">
          <Button color="red" onClick={() => setShowDelete(true) }>Delete</Button>
          { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
        </div>
      </div>
      <DeleteDialog
        id={id}
        mutation={DeleteMutation}
        open={showDelete}
        refetchQueries={[TableQuery]}
        setOpen={setShowDelete}
        onSuccess={onDelete}
      />
    </>
  )
}
